import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ComponentWrapper from "../layout/ComponentWrapper";
import { Heading, Text } from "../../util/typography";
import { ink, charcoal } from "../../util/colors";

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  padding: 50px 84px 50px;
  border-radius: 20px;
  text-align: center;

  background: linear-gradient(135deg, #F4FCDD 0%, #D6EFEF 100%);

  @media (max-width: 768px) {
    padding: 30px 20px 30px;
    border-radius: 10px;

    background: radial-gradient(
      129.53% 140.63% at 0% 1.21%,
      #f4fcdd 26.95%,
      #d6efef 100%
    );
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

const Picture = styled.picture`
  display: block;
`;

const Logo = styled.img`
  display: block;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
`;

const CardHeading = styled(Heading.H2)`
  color: ${ink};
  text-align: center;
`;

const Description = styled(Text.Body)`
  color: ${charcoal};
  text-align: center;
`;

const PatientSupportCard = ({
  desktopImage,
  mobileImage,
  imageAlt,
  heading,
  description,
  className,
}) => {
  return (
    <ComponentWrapper className={className}>
      <CardWrapper>
        {(desktopImage || mobileImage) && (
            <Picture>
              {mobileImage && (
                <source
                  media={`(max-width: 768px)`}
                  srcSet={mobileImage}
                />
              )}

              <Logo src={desktopImage || mobileImage} alt={imageAlt} />
            </Picture>
          )}
        <CardContent>

          {heading && <CardHeading>{heading}</CardHeading>}

          {description && <Description>{description}</Description>}
        </CardContent>
      </CardWrapper>
    </ComponentWrapper>
  );
};

PatientSupportCard.propTypes = {
  desktopImage: PropTypes.string,
  mobileImage: PropTypes.string,
  imageAlt: PropTypes.string,
  heading: PropTypes.node,
  description: PropTypes.node,
  className: PropTypes.string,
};

PatientSupportCard.defaultProps = {
  desktopImage: "",
  mobileImage: "",
  imageAlt: "",
  heading: null,
  description: null,
  className: "",
};

export default PatientSupportCard;
